// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"cf32bd3b","213":"b64dc883","242":"24d7c750","351":"0124011c","453":"6a42122c","569":"0f05b842","955":"0850ccf9"}[chunkId] + ".chunk.js";
};